import React from "react";

function LoadingSpinner() {
    return <div className="loading-spinner margin-auto m-5"></div>
}

export default LoadingSpinner;